(function () {
  if (window.__lgDirectProductLinks) return;
  window.__lgDirectProductLinks = true;

  var productCardSelector = '.t4s-product,.t4s-widget__pr,.t4s-pr-loop-item,[data-product-options],[data-product-handle]';
  var excludedLinkSelector = [
    '[data-action-quickview]',
    '[data-action-atc]',
    '[data-open-mfp-ajax]',
    '[data-open-mfp]',
    '.t4s-pr-quickview',
    '.t4s-pr-addtocart',
    '.t4s-pr-wishlist',
    '.t4s-pr-compare',
    '[data-replace-wishlist]',
    '[data-replace-compare]'
  ].join(',');

  function getProductHandleFromPath(pathname) {
    var match = String(pathname || '').match(/^\/(?:collections\/[^/]+\/)?products\/([^/?#]+)\/?$/i);
    return match && match[1] ? match[1] : '';
  }

  function cleanProductUrl(url) {
    if (url === undefined || url === null || url === '') return url;

    try {
      var parsed = new URL(String(url), window.location.href);
      var handle = getProductHandleFromPath(parsed.pathname);
      if (!handle) return url;

      parsed.pathname = '/products/' + handle;
      parsed.searchParams.delete('variant');
      return parsed.pathname + parsed.search + parsed.hash;
    } catch (error) {
      return url;
    }
  }

  function cleanCurrentProductUrl() {
    var cleanUrl = cleanProductUrl(window.location.href);
    var currentUrl = window.location.pathname + window.location.search + window.location.hash;
    if (cleanUrl !== currentUrl) {
      window.history.replaceState(window.history.state, document.title, cleanUrl);
    }
  }

  function installProductHistoryGuard() {
    if (window.__lgProductHistoryGuard) return;
    window.__lgProductHistoryGuard = true;

    var originalPushState = window.history.pushState;
    var originalReplaceState = window.history.replaceState;

    window.history.pushState = function (state, title, url) {
      return originalPushState.call(this, state, title, cleanProductUrl(url));
    };

    window.history.replaceState = function (state, title, url) {
      return originalReplaceState.call(this, state, title, cleanProductUrl(url));
    };

    cleanCurrentProductUrl();
  }

  function getProductHandle(link) {
    var href = link.getAttribute('href') || '';

    try {
      var parsed = new URL(href, window.location.href);
      var handleFromPath = getProductHandleFromPath(parsed.pathname);
      if (handleFromPath) return handleFromPath;
    } catch (error) {}

    var card = link.closest(productCardSelector);
    if (!card) return '';

    var handle = card.getAttribute('data-product-handle');
    if (handle) return handle;

    var options = card.getAttribute('data-product-options');
    if (!options) return '';

    try {
      return JSON.parse(options).handle || '';
    } catch (error) {
      return '';
    }
  }

  function getDirectUrl(link) {
    var handle = getProductHandle(link);
    return handle ? '/products/' + handle : '';
  }

  function isProductNavigationLink(link) {
    return !!(
      link &&
      link.matches('a[href]') &&
      !link.matches(excludedLinkSelector) &&
      link.closest(productCardSelector) &&
      getProductHandle(link)
    );
  }

  function normalizeLink(link) {
    if (!isProductNavigationLink(link)) return;
    var directUrl = getDirectUrl(link);
    if (link.getAttribute('href') !== directUrl) link.setAttribute('href', directUrl);
  }

  function normalizeProductLinks(root) {
    if (!root) return;
    if (root.nodeType === 1 && root.matches && root.matches('a[href]')) normalizeLink(root);
    if (root.querySelectorAll) root.querySelectorAll('a[href*="/products/"]').forEach(normalizeLink);
  }

  function handleProductNavigation(event) {
    var link = event.target.closest && event.target.closest('a[href]');
    if (!isProductNavigationLink(link)) return;

    var directUrl = getDirectUrl(link);
    link.setAttribute('href', directUrl);

    event.stopPropagation();
    if (event.stopImmediatePropagation) event.stopImmediatePropagation();

    if (event.type !== 'click' || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || link.target === '_blank') return;

    event.preventDefault();
    window.location.assign(directUrl);
  }

  function init() {
    normalizeProductLinks(document);
    if (!window.MutationObserver) return;

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes') normalizeLink(mutation.target);
        else mutation.addedNodes.forEach(normalizeProductLinks);
      });
    }).observe(document.documentElement, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['href']
    });
  }

  installProductHistoryGuard();
  window.addEventListener('click', handleProductNavigation, true);
  window.addEventListener('auxclick', handleProductNavigation, true);
  window.addEventListener('popstate', cleanCurrentProductUrl);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function (event) {
    normalizeProductLinks(event.target);
  });
})();

(function () {
  if (window.__lgRingSizeGuideEnhancement) return;
  window.__lgRingSizeGuideEnhancement = true;

  var retryTimer = null;
  var GUIDE_SELECTOR = '.luminary-ring-size-guide, .lg-wedding-ring-size-guide, .lg-universal-ring-size-guide';

  function isProductPage() {
    return document.body && document.body.classList.contains('template-product');
  }

  function productCollections() {
    if (!document.body) return [];
    return (document.body.getAttribute('data-lg-product-collections') || '').split(',').filter(Boolean);
  }

  function isEligibleRingPage() {
    if (!isProductPage()) return false;
    return productCollections().some(function (handle) {
      return handle === 'women-wedding-rings' || (handle.indexOf('engagement') !== -1 && handle.indexOf('ring') !== -1);
    });
  }

  function findProductForm() {
    return document.querySelector('form[action*="/cart/add"], form[data-type="add-to-cart-form"], .t4s-form__product');
  }

  function compactText(element) {
    return (element && element.textContent || '').replace(/\s+/g, ' ').trim();
  }

  function findOptionBlock(pattern) {
    var scope = document.querySelector('.t4s-product__info-container') || document;
    var candidates = scope.querySelectorAll('[data-swatch-option], .t4s-swatch__option, .tpo_option-container, .tpo_option, .tpo_option-wrapper, fieldset, [data-option]');
    for (var i = 0; i < candidates.length; i += 1) {
      if (pattern.test(compactText(candidates[i]))) return candidates[i];
    }
    return null;
  }

  function findRingSizeAnchor(form) {
    return form.querySelector('.lg-ring-size-option, .lg-wedding-ring-size-option, [data-lg-ring-size-option]') ||
      findOptionBlock(/select\s*ring\s*size|ring size/i);
  }

  function findGuide(form) {
    var guides = form.querySelectorAll(GUIDE_SELECTOR);
    for (var i = 0; i < guides.length; i += 1) {
      if (!guides[i].hidden) return guides[i];
    }
    return guides[0] || null;
  }

  function createGuide() {
    var guide = document.createElement('div');
    guide.className = 'lg-universal-ring-size-guide';
    guide.innerHTML = '<a href="https://www.luminarygem.com/pages/ring-size-guide" target="_blank" rel="noopener"><i class="las la-ring" aria-hidden="true"></i><span>Ring Size Guide</span></a>';
    return guide;
  }

  function ensureStyle() {
    if (document.getElementById('lg-ring-size-guide-enhancement-style')) return;
    var style = document.createElement('style');
    style.id = 'lg-ring-size-guide-enhancement-style';
    style.textContent = [
      '.template-product .luminary-ring-size-guide,.template-product .lg-wedding-ring-size-guide,.template-product .lg-universal-ring-size-guide{display:block!important;margin:10px 0 18px!important}',
      '.template-product .luminary-ring-size-guide__link,.template-product .lg-wedding-ring-size-guide a,.template-product .lg-universal-ring-size-guide a{display:inline-flex!important;align-items:center!important;gap:7px!important;color:#222!important;font-size:14px!important;font-weight:500!important;line-height:1.4!important;text-decoration:underline!important;text-underline-offset:3px!important}',
      '.template-product .luminary-ring-size-guide__link:hover,.template-product .lg-wedding-ring-size-guide a:hover,.template-product .lg-universal-ring-size-guide a:hover{color:#8a6a2f!important}',
      '.template-product .luminary-ring-size-guide__link i,.template-product .lg-wedding-ring-size-guide i,.template-product .lg-universal-ring-size-guide i{font-size:17px!important;line-height:1!important}'
    ].join('\n');
    document.head.appendChild(style);
  }

  function placeGuide() {
    if (!isEligibleRingPage()) return;
    var form = findProductForm();
    if (!form) return;

    ensureStyle();

    var anchor = findRingSizeAnchor(form);
    var guide = findGuide(form) || createGuide();
    guide.hidden = false;

    if (anchor) {
      if (anchor.contains(guide)) return;
      if (anchor.nextElementSibling !== guide) anchor.insertAdjacentElement('afterend', guide);
      return;
    }

    var stoneBlock = findOptionBlock(/select\s*stone\s*size|stone size/i);
    var buttons = form.querySelector('.t4s-product-form__buttons');
    if (stoneBlock && stoneBlock.parentNode) stoneBlock.parentNode.insertBefore(guide, stoneBlock);
    else if (buttons && buttons.parentNode) buttons.parentNode.insertBefore(guide, buttons);
    else if (!guide.parentNode) form.appendChild(guide);
  }

  function scheduleGuide() {
    var attempts = 0;
    if (retryTimer) clearInterval(retryTimer);
    placeGuide();
    retryTimer = setInterval(function () {
      attempts += 1;
      placeGuide();
      if (attempts >= 20) clearInterval(retryTimer);
    }, 500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scheduleGuide);
  else scheduleGuide();
  document.addEventListener('shopify:section:load', scheduleGuide);
  document.addEventListener('tpo_loaded', scheduleGuide);
  document.addEventListener('easify:loaded', scheduleGuide);
})();
